import { Image } from "@mantine/core";

export default function Logo({ h = 32 }) {
	return <Image src="/img/economos_logo.webp" h={h} w={h} />;
}
